import React, { useState, useEffect, useCallback } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { ListItemText, Box, ButtonGroup, Stack, Paper } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import ConfirmDialog from '../../../common/ConfirmDialog';
import UserTaskFormConstruction from "./UserTaskFormConstruction";
import UserTaskFormCDN from "./UserTaskFormCDN";
import UserTaskFormHTML from "./UserTaskFormHTML";

// export default function UserTaskForm(props) {
const UserTaskForm = React.forwardRef((props, ref) => {

    const childRef = React.useRef();

    // const { modelId, taskId, name, setUserGroup, userGroup, setWait } = props;
    const { item, processo, onClose } = props;
    const [open, setOpen] = React.useState(false);
    const [code, setCode] = React.useState();
    const [uri, setUri] = React.useState('');

    const [openUserTaskConfirmDialog, setOpenUserTaskConfirmDialog] = useState(false);
    //--------------------
    const [cards, setCards] = useState([]);
    const [form, setForm] = useState({})
    const [formTp, setFormTp] = useState('Construção');

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            salva();
          }
    }))

    useEffect(() => {
        console.log( item.id);
        
        if( item && processo){
            console.log(processo);
            const task = processo.lstTask.find( (i) => i.idTask === item.id );
            if( task ){
                if( task.html){
                    setFormTp( "HTML" );
                    setCode(task.html);
                }else if( task.form){
                    setCards( task.form)
                }else{
                    setFormTp( "CDN" );
                    setUri( task.cdn)
                }
            }
        }
    }, [])

    function salva(){
        console.log('>>>salva from parent<<<');
        if(childRef && childRef.current) childRef.current.childMethod();
    }

    return (
        <div style={{width:'100%'}}>
                <Stack sx={{ marginLeft:"10px", marginTop: 0 }} direction="row" spacing={2}>
                    <FormControl sx={{width:'180px'}}>
                        <InputLabel variant="standard" htmlFor="uncontrolled-native">
                            Tipo de construção
                        </InputLabel>
                        <NativeSelect
                            value={formTp}
                            inputProps={{
                                name: 'Definição',
                                id: 'formTypeDefinition',
                            }}
                            onChange={(e) => setFormTp(e.target.value)}
                        >
                            <option value={'Construção'}>Construção</option>
                            <option value={'CDN'}>CDN</option>
                            <option value={'HTML'}>Código HTML</option>
                        </NativeSelect>
                    </FormControl>
                    <div>
                        <p style={{fontSize:'small'}}>Obs.: Na pagina gerada, a ação de conclusão e de retorno tem a opção de chamar as funções de callback <span class="pd-code">callbackSubmit(ret)</span> para submit e <span class="pd-code">callbackVoltar()</span> para retornar caso seja implementado essas funções na pagina pai.
                        <br/>Para informação mais detalhada consulte a documentação da função <a href="/doc/documentacao.html#loadUserTaskFromPage">loadUserTaskFromPage</a></p>
                    </div>
                </Stack>

                { formTp === "Construção" && <UserTaskFormConstruction ref={childRef} setForm={setForm} form={form} setCards={setCards} cards={cards} item={item} processo={processo} onClose={onClose}/>}
                { formTp === "CDN" && <UserTaskFormCDN ref={childRef} setForm={setForm} form={form} setCDN={setUri} cdn={uri} item={item} processo={processo} />}
                { formTp === "HTML" && <UserTaskFormHTML ref={childRef} item={item} processo={processo} onClose={onClose} code={code}/>}
                
            <ConfirmDialog
                open={openUserTaskConfirmDialog}
                setOpen={setOpenUserTaskConfirmDialog}
                ok={null}
                cancel="Entendido"
                title="Importante"
                body="É necessário salvar o processo antes de criar atividade de usuário."
            />
        </div>
    );
})

export default UserTaskForm;